import axios from "axios";
import { toNumber } from "../Utils/filter";

//课件类型
export const CourseWareTypeList = {
    ppt: ["ppt", "pptx"],
    word: ["doc", "docx"],
    excel: ["xls", "xlsx"],
    offices: ["ppt", "pptx", "doc", "docx", "xls", "xlsx"],
    pdf: ["pdf"],
    href: ["html"],
    pic: ["png", "jpg", "jpeg", "gif"],
    txt: ["txt"],
    video: [
        "polyv",
        "ogg",
        "avi",
        "f4v",
        "mpg",
        "mp4",
        "flv",
        "wmv",
        "mov",
        "3gp",
        "rmvb",
        "mkv",
        "asf",
        "264",
        "ts",
        "mts",
        "dat",
        "vob",
        "mp3",
        "wav",
        "m4v",
        "webm",
        "quicktime"
    ],
    compression: ["rar", "7z", "zip"]
};

export enum CoursewareType {
    web365 = "0",
    polyv = "1",
    other = "2"
}

export interface CoursewareListItem {
    id: string; // 课件id
    batchNo?: string; // 学期编号
    chapterId?: number; // 所属章节id
    courseName?: string; // 课程名称
    courseNo?: string; // 课程编号
    courseSeq?: string; // 课程序号
    customerCode?: string; // 用户代码
    delStatus?: number; // 删除标识符，0否1是
    isDownload?: BooleanValue; // 是否可以下载，0否1是
    isPublish?: number; // 是否公开，0否1是
    nodeType?: string;
    sourceFileEntity?: SourceFileEntity; // 课件所关联的资源文件信息
    sourceId?: number; // 关联的资源id
    studyStatusEntity?: StudyStatusEntity; // 课件的学习状态
    type?: number; // 0:选择的 1：上传的
    weektimeId?: number; // 周计划id
}

/**
 * 课件所关联的资源文件信息
 */
export interface SourceFileEntity {
    delStatus?: number; // 删除标识符 0未删除1已删除
    description?: string; // 文件说明
    fileCode?: string; // 资源文件code
    fileName?: string; // 资源文件名称
    fileSize?: string; // 文件大小
    fileType?: string; // 文件后缀名
    id?: number; // 资源文件id
    officeViewUrl?: string; // ow365预览url
    storePath?: string; // 资源文件存储路径
    useType?: CoursewareType; // 资源文件类型 应用类型。0:web365 1：polyv 2：外部网页
    viewUrl?: string; // 浏览或下载地址
}

/**
 * 课件的学习状态
 */
export interface StudyStatusEntity {
    coursewareId?: number; // 所属的课件id
    downloadCount?: number; // 下载次数
    id?: string; // 课件学习状态id
    studentId?: number; // 学生id
    studentMarkModel?: { [key: string]: any }; // 学生信息实体
    studentNo?: string; // 学生学号
    studyStatus?: BooleanValue; // 课件学习状态，0否1是
    studyTime?: string; // 学习时间
}

/**
 * 查询课程下的课件
 * @param params
 */
export function getCoursewareList(params: {
    courseNo: string;
    courseSeq: string;
    weekTimeId: number;
}) {
    return axios
        .post<SuccessData<CoursewareListItem[]>>(
            `/student/getCoursewareList`,
            { ...params, weektimeId: params.weekTimeId },
            {
                headers: { "Content-Type": "application/json" }
            }
        )
        .then(res => res.data.data);
}

/**
 * 标记课件为已学习
 * @param item
 */
export function studyCourse(item: CoursewareListItem) {
    item.studyStatusEntity = { ...item.studyStatusEntity, studyStatus: 1 };

    return axios.post(`/student/studyCourse`, item, {
        headers: { "Content-Type": "application/json" }
    });
}

/**
 * 课件下载次数+1
 * 注意此处不能用异步, 否则会被浏览器拦截
 * @param item
 */
export function downloadCourse(item: CoursewareListItem) {
    item.studyStatusEntity = {
        ...item.studyStatusEntity,
        downloadCount: toNumber(item.studyStatusEntity?.downloadCount) + 1
    };

    axios.post(`/student/studyCourse`, item, {
        headers: { "Content-Type": "application/json" }
    });

    window.open(
        `${item.sourceFileEntity?.viewUrl}?attname=${encodeURIComponent(
            item.sourceFileEntity?.fileName || ""
        )}`
    );
}

export interface SourceType {
    id: string; // 课件id
    batchNo?: string; // 学期号码
    chapterId?: number; // 所属章节id
    courseName?: string; // 课程名称
    courseNo?: string; // 课程编号
    courseSeq?: string; // 课程序号
    createUser?: number; // 上传人id
    createUserName?: string; // 上传人姓名
    customerCode?: string; // 用户code
    delStatus?: number; // 删除标识符，0未删除1已删除
    isDownload?: BooleanValue; // 是否可以下载，0否1是
    isPublish?: number; // 是否公开，0否1是
    sourceFileEntity?: SourceFileEntity; // 课件所关联的资源文件信息
    sourceId?: number; // 资源id
    studyStatusEntity?: StudyStatusEntity; // 该课件的学习状态
    type?: number; // 类型，0:选择的 1：上传的
    weektimeId?: number; // 周计划id
}

export interface ChapterType {
    id: string; // 该章节的id
    level: string; // 该章节的层级
    chapterName: string; // 该章节名称
    chapterCode: string; // 该章节代码
    dcCoursewareSourceList?: SourceType[];
    children?: ChapterType[];
}

export interface CourseChaptersInfo {
    learnProgress: string; // 学习进度
    sourceChapter: ChapterType;
}

/**
 * 查询课程下的章节信息
 * @param courseNo
 * @param courseSeq
 */
export function getChapters(courseNo: string, courseSeq: string) {
    return axios
        .post<SuccessData<CourseChaptersInfo>>(
            "/student/getCourseInfo",
            { dcCoursewareSourceParam: { courseNo, courseSeq } },
            {
                headers: { "Content-Type": "application/json" }
            }
        )
        .then(res => res.data.data);
}

/**
 * 把所有资源列表提取出来
 * @param data
 */
export function getResourceListFromChapter(data: ChapterType): SourceType[] {
    const resources: SourceType[] = [];

    if (data.dcCoursewareSourceList)
        resources.push(...data.dcCoursewareSourceList);

    data.children?.forEach(data => {
        const subResources = getResourceListFromChapter(data);
        resources.push(...subResources);
    });

    return resources;
}
